import apiClient from './apiClient';

export const createProfile = async (profileData) => {
    const response = await apiClient.post('/api/business-profile', profileData);
    return response.data;
};

export const getAllProfiles = async () => {
    const response = await apiClient.get('/api/business-profile');
    return response.data;
};

export const getProfile = async (id) => {
    const response = await apiClient.get(`/api/business-profile/${id}`);
    return response.data;
};

export const updateProfile = async (id, updates) => {
    const response = await apiClient.put(`/api/business-profile/${id}`, updates);
    return response.data;
};

export const deleteProfile = async (id) => {
    const response = await apiClient.delete(`/api/business-profile/${id}`);
    return response.data;
};

export const setDefaultProfile = async (id) => {
    const response = await apiClient.patch(`/api/business-profile/${id}/default`, {});
    return response.data;
};
